import React from 'react'
import ReadOnlyTask from '../ReadOnlyTask'
import {FormComponentPropTypes} from '../onboardingTypes'

function CleaningServices(props) {
  return <ReadOnlyTask {...props} />
}

CleaningServices.propTypes = FormComponentPropTypes

export default CleaningServices
